export default "/images/vendor/flag-icon-css/flags/1x1/mr.svg?7211bfd49f97a5ae1253d2172336ade9";